import { DatabaseId } from "@syla/shared/types/helpers/Id";
import { AccountTransactionTypesResponse } from "@syla/shared/types/responses/AccountTransactionTypesResponse";
import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export async function getAccountTransactionTypes(
  accountId: DatabaseId,
): Promise<AccountTransactionTypesResponse["types"]> {
  try {
    const response = await axios.get<AccountTransactionTypesResponse>(
      `/accounts/${accountId}/transactions/types`,
    );
    return response.data.types;
  } catch (error) {
    throwSylaApiError(error);
  }
}
